<template>
    <div>
        <form @submit.prevent="submit">
            <div class="row">
                <form-select
                    :itens="$root.arrays.pergunta"
                    v-model="profissionalizacao.trabalhando"
                    label="Está Trabalhando?"
                    grid="6"
                />
                <form-input
                    v-model="profissionalizacao.local"
                    label="Local"
                    placeholder="Qual o local do Trabalho?"
                    grid="6"
                />
                <form-input
                    v-model="profissionalizacao.horario"
                    label="Horário"
                    placeholder="Qual o Horário ?"
                    grid="6"
                />
                <form-input
                    v-model="profissionalizacao.salario"
                    label="Salário"
                    placeholder="R$ 00,00"
                    grid="6"
                />
                <form-select
                    :itens="$root.arrays.pergunta"
                    v-model="profissionalizacao.registro_carteira"
                    label="Registro em Carteira?"
                    grid="6"
                />
                <form-select
                    :itens="$root.arrays.pergunta"
                    v-model="profissionalizacao.experiencia_anterior"
                    label="Experiências anteriores?"
                    grid="6"
                />
                <form-select
                    :itens="$root.arrays.pergunta"
                    v-model="profissionalizacao.participou_cursos"
                    label="Já participou de cursos profissionalizantes?"
                    grid="6"
                />

                <form-input
                    v-if="profissionalizacao.participou_cursos == 1"
                    v-model="profissionalizacao.qual_curso"
                    label="Quais cursos profissionalizantes?"
                    grid="6"
                />
                <form-select
                    :itens="$root.arrays.pergunta"
                    v-model="profissionalizacao.gostaria_participar"
                    label="Gostaria de participar de cursos profissionalizantes?"
                    grid="6"
                />

                <form-input
                    v-if="profissionalizacao.gostaria_participar == 1"
                    v-model="
                        profissionalizacao.quais_cursos_gostaria_participar
                    "
                    label="Quais cursos gostaria de participar?"
                    grid="6"
                />
                <form-select
                    :itens="$root.arrays.pergunta"
                    v-model="profissionalizacao.deseja_alguma_profissao"
                    label="Deseja seguir alguma profissão?"
                />
                <form-select
                    :itens="$root.ocupacoes"
                    v-model="profissionalizacao.qual_profissao_interesse"
                    label="Qual das profissões, de acordo com a CLASSIFICAÇÃO BRASILEIRA DE OCUPAÇÕES, tem interesse de seguir?"
                />

                <form-textarea-editor
                    class="mt-3"
                    v-model="profissionalizacao.observacoes"
                    label="Observação sobre as competências profissionais identificadas/aptidões"
                />
            </div>
            <div class="row px-2 d-flex justify-content-end">
                <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                </button>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            profissionalizacao: {
                trabalhando: "",
                local: "",
                horario: "",
                salario: "",
                registro_carteira: "",
                experiencia_anterior: "",
                participou_cursos: "",
                gostaria_participar: "",
                quais_cursos_gostaria_participar: "",
                qual_curso: "",
                deseja_alguma_profissao: "",
                qual_profissao_interesse: "",
                observacoes: "",
            },
        };
    },
    mounted() {
        if (this.item.profissionalizacao) {
            this.profissionalizacao = this.item.profissionalizacao;
        }
    },
    methods: {
        submit() {
            this.item.profissionalizacao = this.profissionalizacao;
            this.$emit("submit");
        },
    },
};
</script>
